import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { Co2QuizResults } from '@/models/co2-quiz.model';
import { ShiftCMSState } from '@/store';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { Co2QuizStoreState } from '@/stores/co2-quiz.store';


export default /*@__PURE__*/_defineComponent({
  __name: 'Co2QuizResults',
  setup(__props) {

const store = useStore<ShiftCMSState & { co2: Co2QuizStoreState }>();
const results = computed<Co2QuizResults[]>(() => store.state.co2.results);

const total = computed<number>(() =>
  results.value.reduce((acc: number, v) => (acc += v.co2value), 0),
);

const headers = [
  { title: 'Category', key: 'title', sortable: false },
  { title: 'kg CO₂', key: 'co2value', sortable: false },
];

return (_ctx: any,_cache: any) => {
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Results", -1)),
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          (results.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", null, [
                  _cache[0] || (_cache[0] = _createTextVNode(" Total: ")),
                  _createElementVNode("strong", null, _toDisplayString(total.value), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "small" }, "kg CO₂", -1))
                ]),
                _createVNode(_component_v_data_table, {
                  items: 
            [...results.value]
              .sort((a, b) => b.co2value - a.co2value)
              .filter((v) => v.co2value)
          ,
                  headers: headers
                }, {
                  "item.co2value": _withCtx(({ value }) => [
                    _createElementVNode("strong", null, _toDisplayString(parseFloat(value).toFixed(2)), 1)
                  ]),
                  _: 1
                }, 8, ["items"])
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_2, "There are no results, as no answers have been selected"))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})